export default "__VITE_ASSET__B2lhr_ye__"